import { AuthObject } from "../@types/auth";
import axios from "axios";
import { createContext, PropsWithChildren, useContext, useEffect, useState } from "react";

export interface AuthContextInterface {
  authObj: AuthObject | null,
  login: ( aObj: AuthObject ) => void,
  logout: VoidFunction,
  interceptReady: boolean,
  requesgetUserInfo: ( code: string ) => Promise<AuthObject>,
}
const AuthContext = createContext<AuthContextInterface | null>( null );

const getAuthObjFromLocalStorage = () => {
  return localStorage.getItem( "caiauth" ) ? JSON.parse( "" + localStorage.getItem( "caiauth" ) ) : null;
};

export const AuthProvider = ({children}: PropsWithChildren) => {
  const [authObj, authObjSet] = useState<AuthObject | null>( getAuthObjFromLocalStorage );
  const [interceptReady, interceptReadySet] = useState<boolean>( false );

  const logout = ( isHard = true ) => {
    authObjSet(null);
    localStorage.removeItem( "caiauth" );
    if( isHard ){
      (window as Window).location = `https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${location.origin}/login/callback`;
    }
  };

  const login = ( aObj: AuthObject ) => {
    authObjSet( aObj );
    localStorage.setItem( "caiauth", JSON.stringify( aObj ) );
  };

  const updateAccessToken = ( jwt: string ) => {
    const aObj = getAuthObjFromLocalStorage();
    if( aObj ){
      aObj.accessToken = jwt;
      login( aObj );
    }
  };

  const requesgetUserInfo = ( code: string ) => {
    const payload = {
      code: code,
      redirect: `${window.location.origin}/login/callback`
    };
    return fetch("/rest/auth/msauth/callback", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      if (data && data.isMsUser) {
        login( data );
        return data;
      } else {
        console.error("Authentication failed");
        // if( statusDiv ){
        //   statusDiv.textContent = "Authentication failed....";
        // }
        throw( "Authentication Failed" );
      }
    })
    .catch(error => {
      console.error("An error occurred during authentication:", error);
      throw( error );
    });
    // .finally(()=>{
    //   statusSet( "done" );
    // });
  };

  useEffect(()=>{
    if( authObj && authObj.accessToken ){
      axios.interceptors.request.use(
        config => {
          // Add or modify a header in the request configuration
          config.headers.Authorization = authObj.accessToken;
          return config;
        },
        error => {
          console.log( "errrrrrrr", error );
          throw( error );
        }
      );
      axios.interceptors.response.use(
        response => {
          if( response.config.url ){
            const requestUrlObj = new URL( response.config.url, location.origin );
            if( requestUrlObj.origin === location.origin ){
              const headers = response.headers;
              let jwt;
              Object.entries( headers ).forEach(([name, value]) => {
                if( name === "jwt" ){
                  if( value ){
                    jwt = value;
                  }else{
                    logout( false );
                  }
                }
              });
              if( jwt ){
                updateAccessToken( jwt );
              }
            }
          }
          return response;
        },
        error => {
          const statusCode = error.response.status;
          if( statusCode == 401 ){
            const requestUrlObj = new URL( error.config.url, location.origin );
            if( requestUrlObj.origin === location.origin ){
              logout( false );
            }
          }
          throw( error );
        }
      );
      interceptReadySet( true );
    }
  }, [ authObj ]);

  return (
    <AuthContext.Provider value={{ authObj, login, logout, interceptReady, requesgetUserInfo }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext( AuthContext );